var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-container"},[_c('div',{staticClass:"tips"},[_c('h2',[_vm._v(_vm._s(_vm.data.title))]),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.data.memo)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }